export var StockTransferAPIKeys = {
    create: 'stockTransferCreate',
    update: 'stockTransferUpdate',
    get: 'stockTransferGetById',
    paging: 'stockTransferPaging',
    statusProgress: 'stockTransferStatusProgress'
};
